<div class="d-flex text-end justify-content-between align-items-center">
  <h2>Sales By Property</h2>
  <div class="legend-row">

    <div class="legend-container">
      <div class="legend-color" style="text-align: left; background-color: lightgrey"></div>
      <div class="legend-text">Guest</div>
    </div>

    <div class="legend-container">
      <div class="legend-color" style="text-align: left; background-color: hotpink;"></div>
      <div class="legend-text">Owner</div>
    </div>

    <div class="legend-container">
      <div class="legend-color" style="text-align: left; background-color: lightpink;"></div>
      <div class="legend-text">Owner Guest</div>
    </div>

    <div class="legend-container">
      <div class="legend-color" style="text-align: left; background-color: darkgray;"></div>
      <div class="legend-text">Maintenance</div>
    </div>

    <div class="legend-container">
      <div class="legend-color" style="text-align: left; background-color: red;"></div>
      <div class="legend-text">Cancel</div>
    </div>

  </div>
</div>
<ag-grid-angular
	style="width: 100%; margin: 20px 0px;"
	class="ag-theme-balham"
	[gridOptions]="gridOptions"
	[rowData]="gridData"
	(gridReady)="onGridReady($event)"
	(firstDataRendered)="onFirstDataRendered($event)"
	[groupDefaultExpanded]="groupDefaultExpanded"
	(rowGroupOpened)="onRowGroupOpened($event)"
>
</ag-grid-angular>
